import BaseKpiStatCard from './BaseKpiStatCard.vue'
import BaseStatusProgress from './BaseStatusProgress.vue'
import BaseDonutChart from './BaseDonutChart.vue'
import BaseRankingBarChart from './BaseRankingBarChart.vue'
import BaseDistributionBarChart from './BaseDistributionBarChart.vue'
import BaseReconciliationPanel from './BaseReconciliationPanel.vue'
import BaseRulesPanel from './BaseRulesPanel.vue'
import BaseDataTableFilter from './BaseDataTableFilter.vue'
import BaseAccordionDrilldown from './BaseAccordionDrilldown.vue'
import BaseDetailDrawer from './BaseDetailDrawer.vue'
import BaseStepper from './BaseStepper.vue'
import BaseTimeline from './BaseTimeline.vue'
import BaseDropzone from './BaseDropzone.vue'
import BaseStatusPill from './BaseStatusPill.vue'
import BaseEntityBadge from './BaseEntityBadge.vue'
import BaseFigures from './BaseFigures.vue'
import BaseButtonAction from './BaseButtonAction.vue'
import DashboardSection from './DashboardSection.vue'
import DashboardGrid from './DashboardGrid.vue'

export default {
  kpi_stat_card: BaseKpiStatCard,
  status_progress: BaseStatusProgress,
  donut_chart: BaseDonutChart,
  ranking_bar_chart: BaseRankingBarChart,
  distribution_bar_chart: BaseDistributionBarChart,
  reconciliation_panel: BaseReconciliationPanel,
  rules_panel: BaseRulesPanel,
  data_table_filter: BaseDataTableFilter,
  accordion_drilldown: BaseAccordionDrilldown,
  detail_drawer: BaseDetailDrawer,
  stepper: BaseStepper,
  timeline: BaseTimeline,
  dropzone: BaseDropzone,
  status_pill: BaseStatusPill,
  entity_badge: BaseEntityBadge,
  figures: BaseFigures,
  button: BaseButtonAction,
  section: DashboardSection,
  grid: DashboardGrid
}
